/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import configure from "react-widgets/lib/configure";
import FrontendLocaleManager from "@novivia/localization/FrontendLocaleManager";
import {getLanguage} from "language";
import momentLocalizer from "react-widgets/lib/localizers/moment";
import React, {Component} from "react";
import RWDateTimePicker from "react-widgets/lib/DateTimePicker";

// Make sure React Widgets' DateTimePicker component is properly localized
// using our own instance of moment.
configure.setDateLocalizer(momentLocalizer(FrontendLocaleManager.moment));

/**
 * DateTimePicker that wraps RWDateTimePicker but passes in adequate
 * localization.
 */
export default class DateTimePicker extends Component {
  render() {
    return (
      <RWDateTimePicker
        {...this.props}

        // FIXME: Support more languages.
        culture={getLanguage() === "en" ? "en-US" : "fr-FR"}
      />
    );
  }
}



// WEBPACK FOOTER //
// ../datetime/DateTimePicker.js